// extracted by mini-css-extract-plugin
export default {"trainerDataDialog":"AddTrainerDialog_trainerDataDialog__IU8r4","submit":"AddTrainerDialog_submit__r-Pbk","submitText":"AddTrainerDialog_submitText__7Vt4H"};